import {
  useMediaQuery 
} from "./use-media-query"

export const useIsMobile = () => {
  const isDesktop = useMediaQuery("(min-width: 768px)")

  const isMobile = useMediaQuery("(max-width: 767px)")

  return {
    isDesktop,
    isMobile
  }
}
